import "./../img/g500_media_contacts.jpg";
import { trans } from "./../helper/trans";
import { modal } from "./../helper/modal";

$("#trademark_modal_link").on("click", function () {
    modal(`<div class="uk-padding">${trans("trademark_popup")}</div>`, true, false);
});
